// =============================
// File: src/components/user/ActiveReferralsList.jsx
// =============================
import React from 'react';
import { Users, Calendar, DollarSign, Package } from 'lucide-react';

function ActiveReferralsList({ summary }) {
  if (!summary) return null;

  const { active_referrals = [] } = summary;

  function formatDate(isoDate) {
    if (!isoDate) return '';
    const date = new Date(isoDate);
    return date.toLocaleDateString('es-PE', { 
      day: '2-digit', 
      month: 'short', 
      year: 'numeric' 
    });
  }

  return (
    <div className="space-y-6">
      {/* Active Referrals */}
      {active_referrals.length > 0 ? (
        <div>
          <div className="flex items-center gap-2 mb-4">
            <Users className="w-5 h-5 text-brand-primary" />
            <h2 className="text-lg font-extrabold font-montserrat text-slate-800">
              Referidos Activos ({active_referrals.length})
            </h2>
          </div>

          <div className="space-y-3">
            {active_referrals.map((referral) => {
              return (
                <div
                  key={referral.id}
                  className="bg-white rounded-xl shadow-sm border border-slate-200 p-4 hover:shadow-md transition-shadow"
                >
                  <div className="flex items-start justify-between mb-3">
                    <div className="flex items-center gap-3">
                      <div className="w-12 h-12 bg-brand-primary/10 rounded-xl flex items-center justify-center">
                        <Users className="w-6 h-6 text-brand-primary" />
                      </div>
                      <div>
                        <h3 className="font-extrabold font-montserrat text-slate-800">
                          {referral.referred_username}
                        </h3>
                        <p className="text-sm text-slate-500 font-montserrat">
                          {referral.referred_phone}
                        </p>
                      </div>
                    </div>
                    <div className="text-right">
                      <p className="text-2xl font-extrabold font-montserrat text-brand-primary">
                        S/ {referral.total_earnings?.toFixed(2) || '0.00'}
                      </p>
                      <p className="text-xs text-slate-500 font-montserrat">Total ganado</p>
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-3 pt-3 border-t border-slate-100">
                    <div className="flex items-center gap-2">
                      <Package className="w-4 h-4 text-slate-400" />
                      <div>
                        <p className="text-xs text-slate-500 font-montserrat">Envíos</p>
                        <p className="text-sm font-bold font-montserrat text-slate-700">
                          {referral.total_deliveries || 0}
                        </p>
                      </div>
                    </div>

                    <div className="flex items-center gap-2">
                      <Calendar className="w-4 h-4 text-slate-400" />
                      <div>
                        <p className="text-xs text-slate-500 font-montserrat">Expira en</p>
                        <p className="text-sm font-bold font-montserrat text-slate-700">
                          {referral.days_remaining} días
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="mt-3 pt-3 border-t border-slate-100">
                    <div className="flex items-center justify-between text-xs">
                      <span className="text-slate-500 font-montserrat">
                        Iniciado: {formatDate(referral.created_at)}
                      </span>
                      <span className="text-slate-500 font-montserrat">
                        Vence: {formatDate(referral.expiration_date)}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        /* Empty State */
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-12 text-center">
          <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Users className="w-8 h-8 text-slate-400" />
          </div>
          <h3 className="text-lg font-extrabold font-montserrat text-slate-800 mb-2">
            No tienes referidos activos
          </h3>
          <p className="text-sm text-slate-500 font-montserrat mb-4">
            Comparte tu código y empieza a ganar dinero con cada envío
          </p>
        </div>
      )}
    </div>
  );
}

export default ActiveReferralsList;